import { useEffect, useState } from 'react';
import {
  ADDRESS_TYPE_FORM_OPTIONS,
  DEFAULT_WALLET_ADDRESS_FORM,
  findCoinByCode,
  formToPayload,
  getCoinOptionLabel,
  resolveImageUrl,
  rowToForm,
} from './walletAddressConstants';

export default function WalletAddressEditModal({
  open,
  row,
  coinPayTypes,
  onClose,
  onSubmit,
  submitting,
}) {
  const isEdit = Boolean(row?.id);
  const [form, setForm] = useState(DEFAULT_WALLET_ADDRESS_FORM);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm(rowToForm(row, coinPayTypes));
      setError('');
    }
  }, [open, row?.id, coinPayTypes]);

  if (!open) {
    return null;
  }

  const selectedCoin = findCoinByCode(coinPayTypes, form.cryptoCurrency);

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  function resetForm() {
    setForm(rowToForm(row, coinPayTypes));
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!form.addressType?.trim()) {
      setError('請選擇地址類型');
      return;
    }
    if (!isEdit && !form.cryptoCurrency?.trim()) {
      setError('請選擇數字貨幣');
      return;
    }
    if (!form.address?.trim()) {
      setError('請填寫錢包地址');
      return;
    }
    if (form.sort === '' || form.sort == null) {
      setError('請填寫顯示順序');
      return;
    }
    setError('');
    await onSubmit(formToPayload(form, row?.id, coinPayTypes));
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>{isEdit ? '修改' : '新增'}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="wallet-address-form">
              <div className="wallet-address-form__row">
                <label htmlFor="walletAddressType">
                  <span className="required-mark">*</span> 地址類型
                </label>
                <select
                  id="walletAddressType"
                  value={form.addressType}
                  disabled={isEdit}
                  onChange={(e) => updateField('addressType', e.target.value)}
                >
                  {ADDRESS_TYPE_FORM_OPTIONS.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="wallet-address-form__row">
                <label htmlFor="walletCryptoCurrency">
                  <span className="required-mark">*</span> 數字貨幣
                </label>
                <select
                  id="walletCryptoCurrency"
                  value={form.cryptoCurrency}
                  disabled={isEdit}
                  onChange={(e) => updateField('cryptoCurrency', e.target.value)}
                >
                  <option value="">請選擇</option>
                  {(coinPayTypes || []).map((coin) => (
                    <option key={coin.code} value={coin.code}>
                      {getCoinOptionLabel(coin)}
                    </option>
                  ))}
                </select>
              </div>

              <div className="wallet-address-form__row">
                <label>貨幣名稱</label>
                <div className="wallet-address-form__static">
                  {selectedCoin ? getCoinOptionLabel(selectedCoin) : '—'}
                </div>
              </div>

              <div className="wallet-address-form__row">
                <label>貨幣圖標</label>
                <div className="wallet-address-form__icon">
                  {selectedCoin?.image ? (
                    <img src={resolveImageUrl(selectedCoin.image)} alt={selectedCoin.name || selectedCoin.code} />
                  ) : (
                    <span className="wallet-address-form__static">—</span>
                  )}
                </div>
              </div>

              <div className="wallet-address-form__row">
                <label htmlFor="walletAddress">
                  <span className="required-mark">*</span> 錢包地址
                </label>
                <input
                  id="walletAddress"
                  type="text"
                  value={form.address}
                  onChange={(e) => updateField('address', e.target.value)}
                />
              </div>

              <div className="wallet-address-form__row">
                <label htmlFor="walletSort">
                  <span className="required-mark">*</span> 顯示順序
                </label>
                <input
                  id="walletSort"
                  type="number"
                  value={form.sort}
                  onChange={(e) => updateField('sort', e.target.value)}
                />
              </div>

              <div className="wallet-address-form__row">
                <label>
                  <span className="required-mark">*</span> 狀態
                </label>
                <div className="wallet-address-form__radios">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="walletStatus"
                      value="1"
                      checked={form.status === '1'}
                      onChange={() => updateField('status', '1')}
                    />
                    啟用
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="walletStatus"
                      value="0"
                      checked={form.status === '0'}
                      onChange={() => updateField('status', '0')}
                    />
                    禁用
                  </label>
                </div>
              </div>
            </div>

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-warning" onClick={resetForm} disabled={submitting}>
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
